import React from 'react';
import { globalStore } from 'stores/globalStore';
import Service from 'services/service';

const CartProductDetail = ({
  title,
  description,
  currentPrice,
  originalPrice,
  discount,
  deliveryDate,
  primaryImage,
  isSelected,
  id,
  cartItemId,
  size,
  quantity,
}) => {
  const { cartPageData, setCartPageData, setCartCount, setUpdateCartPageData } =
    globalStore();

  const handleQuantityChange = async (change) => {
    const updatedItems = cartPageData.items.map((item) => {
      if (item.customTShirtPrint._id === cartItemId) {
        const newQuantity = item.quantity + change;
        return {
          ...item,
          quantity: newQuantity > 0 ? newQuantity : 1,
        };
      }
      return item;
    });

    const updatedCartData = {
      ...cartPageData,
      items: updatedItems,
    };

    setCartPageData(updatedCartData);

    const payload = {
      cartId: cartPageData._id,
      items: updatedItems.map((item) => ({
        customTShirtPrintId: item.customTShirtPrint._id,
        quantity: item.quantity,
      })),
    };

    try {
      const data = await Service.updateCartService(payload);

      // Preserve isSelected state from current items after API response
      const selectionMap = {};
      cartPageData.items.forEach((item) => {
        selectionMap[item.customTShirtPrint._id] = item.isSelected;
      });
      const mergedItems = data.data.items.map((item) => ({
        ...item,
        isSelected: selectionMap[item.customTShirtPrint._id] || false,
      }));

      setCartPageData({ ...data.data, items: mergedItems });
      setUpdateCartPageData(data.data);
      setCartCount(data.data.items.reduce((sum, item) => sum + item.quantity, 0));
    } catch (error) {
      console.error('Error updating cart:', error);
      setCartPageData(cartPageData);
    }
  };

  const handleSelection = () => {
    const updatedItems = cartPageData.items.map((item) => {
      if (item.customTShirtPrint._id === cartItemId) {
        return {
          ...item,
          isSelected: !item.isSelected,
        };
      }
      return item;
    });

    setCartPageData({
      ...cartPageData,
      items: updatedItems,
    });
  };

  return (
    <div className="product-detail">
      <div className="product-detail__item">
        <img
          src={primaryImage}
          alt="Productimage"
          className="product-detail__image"
        />
        <div className="product-detail__info">
          <div className="product-detail__description">
            <h5 className="product-detail__title ui heading size-headings">
              {title}
            </h5>
            <p className="product-detail__delivery-date ui text size-text3xl">
              {description}
            </p>
          </div>
          <div className="product-detail__selectors">
            <p>Size: {size}</p>
            <div className="product-detail__quantity">
              <button
                onClick={() => handleQuantityChange(-1)}
                className="product-detail__quantity-btn"
              >
                −
              </button>
              <span className="product-detail__quantity-value">{quantity}</span>
              <button
                onClick={() => handleQuantityChange(1)}
                className="product-detail__quantity-btn"
              >
                +
              </button>
            </div>
          </div>
          <div className="product-detail__pricing">
            <p className="product-detail__current-price ui text size-text3xl">
              {currentPrice}
            </p>
            <p className="product-detail__original-price ui text size-text3xl">
              {originalPrice}
            </p>
            <p className="product-detail__discount ui text size-text3xl">
              {discount}
            </p>
          </div>
          <p className="product-detail__delivery-date ui text size-text3xl">
            <span>Deliver by&nbsp;</span>
            <span className="product-detail__delivery-date-span">
              {deliveryDate}
            </span>
          </p>
        </div>
      </div>
      <div
        onClick={handleSelection}
        className={`product-detail__view ${isSelected ? 'product-detail__view--selected' : ''}`}
      >
        {isSelected && (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </div>
    </div>
  );
};

export default CartProductDetail;
